/**
 * Bouton « i » du résumé de notation (snippets/tiloa-rating-summary.liquid).
 * Ouvre une courte note de provenance. Sans JavaScript, la note reste lue par
 * les lecteurs d'écran grâce à aria-describedby ; seul l'affichage à l'écran
 * en dépend.
 */
(function () {
  'use strict';

  function fermerTout(sauf) {
    document.querySelectorAll('.tiloa-rs__info.is-open').forEach(function (zone) {
      if (zone === sauf) return;
      zone.classList.remove('is-open');
      var btn = zone.querySelector('[data-tiloa-rs-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tiloa-rs-toggle]');
    if (!btn) {
      if (!e.target.closest('.tiloa-rs__note')) fermerTout(null);
      return;
    }
    e.preventDefault();
    var zone = btn.closest('.tiloa-rs__info');
    // Largeur mesurée AVANT d'ouvrir : sur mobile, une bulle qui déborde élargit
    // la fenêtre de mise en page, et window.innerWidth renverrait cette largeur gonflée.
    var largeur = document.documentElement.clientWidth;
    var ouvrir = !zone.classList.contains('is-open');
    fermerTout(zone);
    zone.classList.toggle('is-open', ouvrir);
    btn.setAttribute('aria-expanded', ouvrir ? 'true' : 'false');

    // Garde la note entière à l'écran, sans jamais la laisser déborder, même
    // un instant : sur mobile, une bulle qui dépasse élargit la page et le
    // débordement subsiste ensuite. On mesure donc sa largeur en position fixe
    // à l'origine de l'écran (où elle tient forcément), on calcule sa place,
    // puis on la pose directement au bon endroit.
    var note = zone.querySelector('[data-tiloa-rs-note]');
    if (ouvrir && note) {
      var marge = 12;
      note.style.cssText = 'position:fixed;left:0;top:0;visibility:hidden;transform:none;translate:none;max-width:' + Math.min(290, largeur - 2 * marge) + 'px';
      var w = note.getBoundingClientRect().width;
      var ancre = zone.getBoundingClientRect();
      var cible = ancre.left - 10;
      if (zone.closest('.reviews__summary')) cible = ancre.left + ancre.width / 2 - w / 2;
      cible = Math.max(marge, Math.min(cible, largeur - marge - w));
      note.style.cssText = 'left:' + Math.round(cible - ancre.left) + 'px;right:auto;transform:none;translate:none;max-width:' + Math.min(290, largeur - 2 * marge) + 'px';
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var ouverte = document.querySelector('.tiloa-rs__info.is-open');
    if (!ouverte) return;
    fermerTout(null);
    var btn = ouverte.querySelector('[data-tiloa-rs-toggle]');
    if (btn) btn.focus();
  });
})();
